import PesquisaNcmRepository from '@/repositories/PesquisaNcm';

// state
const state = () => ({
  pesquisa: [],
  ordenamento: null,
  navegaResultados: false,
  paginaNavegacao: 1
});

// getters
const getters = {
  getPesquisa: (state) => {
    return JSON.parse(Buffer.from(state.pesquisa, "base64"));
  },
  getOrdenamento: (state) => {
    return state.ordenamento
  },
  getNavegaResultados: (state) => {
    return state.navegaResultados
  },
  getPaginacaoNavegacao: (state) => {
    return state.paginaNavegacao
  }
};

// mutations
const mutations = {
  SET_PESQUISA (state, pesquisa) {
    state.pesquisa = Buffer.from(JSON.stringify(pesquisa)).toString("base64")
  },
  SET_ORDENAMENTO (state, ordenamento) {
    state.ordenamento = ordenamento
  },
  SET_NAVEGA_RESULTADOS (state, navegaResultados) {
    state.navegaResultados = navegaResultados
  },
  SET_PAGINACAO_NAVEGACAO (state, paginaNavegacao) {
    state.paginaNavegacao = paginaNavegacao
  }
}

// actions
const actions = {
  async fetchPesquisaMtrzCancel ({ commit }, dados) {
    commit('SET_PESQUISA', [])
    const response = await PesquisaNcmRepository.pesquisaNcmMtrzCancel(dados)

    // commit('SET_PESQUISA', response.data)

    return response
  },
  async fetchPesquisaMtrz ({ commit }, dados) {
    commit('SET_PESQUISA', [])
    const response = await PesquisaNcmRepository.pesquisaNcmMtrz(dados)

    commit('SET_PESQUISA', response.data)

    return response
  },
  async fetchNcmVigente ({ commit }, dados) {

    const response = await PesquisaNcmRepository.pesquisaNcmVigente(dados)

    return response
  },
  resetPesquisa ({ commit }) {
    commit('SET_PESQUISA', [])
  },
  setOrdenamento ({ commit }, ordenamento) {
    commit('SET_ORDENAMENTO', ordenamento)
  },
  setNavegaResultados ({ commit }, navegaResultados) {
    commit('SET_NAVEGA_RESULTADOS', navegaResultados)
  },
  setPaginacaoNavegacao ({ commit }, paginacaoNavegacao) {
    commit('SET_PAGINACAO_NAVEGACAO', paginacaoNavegacao)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
